/**
 * IMPORTANT:
 * These values are used to populate the dropdown options in the signup form.
 * MOST of these map directly to fields in HubSpot and are case sensitive.
 * Do not change the values without confirming these map to the correct fields in HubSpot.
 */

export enum CountryValue {
  UnitedStates = "United States",
  Canada = "Canada",
  UnitedKingdom = "United Kingdom",
  Australia = "Australia",
  NewZealand = "New Zealand",
  Other = "__other__",
}

export enum YearsOpenValue {
  NotOpenYet = "Not open yet",
  LessThan1Year = "Less than 1 year",
  OneToFiveYears = "1-5 years",
  FiveToTenYears = "5-10 years",
  TenPlusYears = "10+ years",
}

export enum RevenueValue {
  LessThan8K = "$0-$8k",
  EightToTwentyFiveK = "$8k-$25k",
  TwentyFiveToThirtyFiveK = "$25k-$35k",
  ThirtyFiveKPlus = "$35k+",
  PreferNotToShare = "Prefer not to share",
}

export enum BusinessNeedsValue {
  LeadGenerationAndConversion = "Lead Generation and Conversion",
  WorkoutTracking = "Workout Tracking",
  BrandedMembersApp = "Branded Members App",
  GymWebsite = "Gym Website",
  ManageBilling = "Manage Billing",
  CommunicatingWithMembers = "Communicating with members",
  ProductSales = "Product Sales",
  Other = "Other",
}
